import decodeAfacodes from 'modules/CitizenPortal/services/calls/geo/decodeAfacodes'
import { getPolygonCenter } from '../getPolygonCenter'
import { createAFACodePinLayer } from '../createAFACodePinLayer'
import { moveMapView } from '../moveMapView'

export async function AFACodeDecode({
  AFA_CODE,
  mapInstance,
  view,
  _getMarkingData,
  // openDrawer,
}: {
  mapInstance: any
  AFA_CODE: string
  view: any
  _getMarkingData: any
  openDrawer?: any
}) {
  const map = mapInstance.current
  if (!map) return

  try {
    // const res = await fetch(`https://api.cep.afa.codes/geo:afa:${AFA_CODE}`)
    // const data = await res.json()

    // const { logistic_id, area, side } = data.features[0].properties
    // const geometry = data.features[0].geometry

    const res = await decodeAfacodes({
      data: { afacode: AFA_CODE },
    })
    const { area, side } = res.body.afacode.properties
    const logistic_id = res.body.afacode.id
    const geometry = res.body.afacode.geometry

    const { centerLat, centerLon } = await getPolygonCenter(geometry)

    // Cria nova layer com os pins
    const newPin = {
      id: logistic_id,
      lat: centerLat,
      lon: centerLon,
      type: 'afacode',
      data: {
        area: area,
        side: side,
        logistic_id: logistic_id,
        geometry: geometry,
        lat: centerLat,
        lon: centerLon,
      },
    }
    const afaLayer = createAFACodePinLayer({ pin: newPin })
    if (afaLayer) {
      afaLayer.setZIndex(999)
      map.addLayer(afaLayer)
    }
    //MOVIMENTANDO O MAPA PARA O PONTO CLICADO
    moveMapView({ map, view, lat: centerLat, lon: centerLon, noZoom: true })

    //ABRINDO ENTIDADE AFACODE NO DRAWER
    // openDrawer({ type: 'afacode', data: { area: area, side: side, logistic_id: logistic_id, geometry: geometry } })

    //CHAMANDO FUNÇÃO DE PREENCHER ENDEREÇO
    _getMarkingData({ centerLat, centerLon })
  } catch (err) {
    console.error('Erro ao buscar polígono:', err)
  }
}
